import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var addFileRes;
export const addFileTodo = createAsyncThunk('addFile', async (data) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))

    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'library/add-file',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "master_folder_id": data.folder_id,
                "filename": data.file_path,
                "filetype": data.file_type,
                "filesize": (data.file_size).toString() + ' kb',
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return addFileRes = res.data
    } catch (error) {
        return addFileRes = error.response.data
    }
})